import type { BigNumber, BigNumberish } from '@ethersproject/bignumber';
import { MaxUint256 } from '@ethersproject/constants';
import type { CoinMode } from '@ui/hooks/useCoinMode';
import type { ContractReceipt, VenoSDK } from '@veno-app/sdk';

export const getReceivedCoin = (
  receipt: ContractReceipt,
  coinMode: CoinMode,
  sdk: VenoSDK,
): BigNumber | null => {
  if (coinMode === 'cro') return sdk.LiquidCro.getReceivedLcro(receipt);
  return sdk.LiquidAtom.getReceivedLatom(receipt);
};

export const doApprovals = async (
  sdk: VenoSDK,
  account: string,
  amount: BigNumberish,
  setNSteps: (n: number) => void,
  setCurrentStep: (step: number) => void,
  coinMode: CoinMode,
) => {
  setNSteps(1);
  setCurrentStep(1);
  if (coinMode === 'cro') return;

  const allowance = await sdk.Atom.allowance(
    account ?? '',
    sdk.LiquidAtom.contractAddress,
  );
  if (allowance.lt(amount)) {
    setNSteps(2);
    setCurrentStep(1);
    const approveRet = await sdk.Atom.approve(
      sdk.LiquidAtom.contractAddress,
      MaxUint256,
    );
    await approveRet.txReceiptPromise;
    setCurrentStep(2);
  }
};
